import React, { useEffect, useState } from 'react';
import { Card, MetricCard, Plate } from '../components/Card';
import { getStock } from '../api';

const fmt = n => n ? n.toLocaleString('ru-RU', { maximumFractionDigits: 0 }) + ' ₽' : '0 ₽';

export default function Stock() {
  const [items, setItems] = useState([]);
  const [lowOnly, setLowOnly] = useState(false);

  useEffect(() => { getStock(lowOnly).then(setItems).catch(() => {}); }, [lowOnly]);

  const totalValue = items.reduce((s, i) => s + i.total_value, 0);
  const lowCount = items.filter(i => i.quantity <= 5).length;

  return (
    <div>
      <div className="kp-hero">
        <Plate>Операции · склад</Plate>
        <h1>Склад</h1>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 24 }}>
        <MetricCard title="Позиций на складе" value={items.length} />
        <MetricCard title="Общая стоимость" value={fmt(totalValue)} color="var(--accent2)" />
        <MetricCard title="Критический остаток" value={lowCount} sub="≤5 штук" color={lowCount > 0 ? 'var(--red)' : 'var(--green)'} />
      </div>

      <Card title="Остатки" action={
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13 }}>
          <input type="checkbox" checked={lowOnly} onChange={e => setLowOnly(e.target.checked)} />
          Только критические
        </label>
      }>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border)' }}>
                {['Товар', 'Кол-во', 'Цена', 'Стоимость', 'Статус'].map(h => (
                  <th key={h} style={{ padding: '8px 12px', textAlign: 'left', color: 'var(--text2)', fontSize: 12 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => {
                const status = item.quantity <= 0 ? 'Нет' : item.quantity <= 5 ? 'Мало' : 'Норма';
                const color = item.quantity <= 0 ? 'var(--red)' : item.quantity <= 5 ? 'var(--yellow)' : 'var(--green)';
                return (
                  <tr key={i} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '10px 12px', maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.name}</td>
                    <td style={{ padding: '10px 12px', fontWeight: 600 }}>{item.quantity}</td>
                    <td style={{ padding: '10px 12px', color: 'var(--text2)' }}>{fmt(item.cost_price)}</td>
                    <td style={{ padding: '10px 12px', fontWeight: 600 }}>{fmt(item.total_value)}</td>
                    <td style={{ padding: '10px 12px' }}>
                      <span style={{ color, fontWeight: 600, fontSize: 12 }}>● {status}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {!items.length && <div style={{ padding: 20, color: 'var(--text2)', textAlign: 'center' }}>Нет данных</div>}
        </div>
      </Card>
    </div>
  );
}
